(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["bespoke"]) return;
  try {
    

    $(document).ready(function ()
    {

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    

    $(document).ready(function ()
    {
    JL.blog.init();
    })



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bridal"]) return;
  try {
    

    $(document).ready(function ()
    {
      JL.hero.init();
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
    $(document).ready(function ()
    {
    JL.cart.init();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    



    $(document).ready(function ()
    {
         JL.collection.init();
    })




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index_hero_slider"] && !window.DesignMode) return;
  try {
    



    $(document).ready(function ()
    {
    JL.hero.init();
    })




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ourstory"]) return;
  try {
    

    $(document).ready(function ()
    {
      JL.hero.init();
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

    $(document).ready(function ()
    {
    JL.pdp.init();
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store"]) return;
  try {
    
    jQuery(document).ready(function ()
    {
    jQuery('.store-header h1').click(function(){
    jQuery(this).toggleClass('open');
    jQuery('.store-header .nav').slideToggle();
    });
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team1"]) return;
  try {
    

    $(document).ready(function ()
    {

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team2"]) return;
  try {
    

    $(document).ready(function ()
    {

    });


  } catch(e) { console.error(e); }
})();
      })();
